'use client';

import { PageWrapper } from '@/components/layout/page-wrapper/page-wrapper';
import { ReviewFormShell } from '@/widgets/me-reviews/review-form-shell';

import type { IMasterclass } from '@/entities/masterclass/types';

type AddReviewPageClientProps = {
  masterclass: IMasterclass;
};

export const AddReviewPageClient = ({
  masterclass,
}: AddReviewPageClientProps) => {
  return (
    <PageWrapper className="justify-center items-center">
      <div className="flex gap-8 w-full justify-center items-center flex-col">
        <ReviewFormShell masterclass={masterclass} variant="page" />
      </div>
    </PageWrapper>
  );
};
